import Proptypes from "prop-types";
import dayjs from "@shared/dayjs";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button/Button";
import { CheckSolidV6 } from "@shared/v2/Icomoon";
import DatePicker from "@shared/v2/DatePicker";
import TextInput from "@shared/v2/TextInput";
import { DATE_FORMAT } from "@shared/v2/DateSelector/utils/constants";
import OutcomeSelection from "../../../Tasks/components/OutcomeSelection";

const AppointmentCompleteModal = ({ modalOpen, closeModal, handleSubmit, task, updateTask }) => {
  const handleDateOnChange = (value) => {
    const parsedValue = dayjs(value, "MM/DD/YYYY hh:mm A");
    updateTask("due_on", parsedValue.format("YYYY-MM-DD"));
    updateTask("scheduled_time", parsedValue.unix());
  };

  return (
    <Modal
      className="tw-flex tw-justify-center tw-items-center"
      // 636px = 616px from Figma + 10px for each horizontal padding (20px)
      dialogClassName="tw-w-[636px] tw-h-auto"
      contentClassName="tw-w-full tw-h-full"
      backdrop="static"
      show={modalOpen}
      onHide={closeModal}
    >
      <Modal.Header
        titleClassName="tw-mb-32px tw-text-neutral-gray-75"
        title="Complete Appointment"
        closeButton
      />

      <Modal.Body className="tw-mb-32px tw-max-h-[70vh] tw-overflow-auto">
        <div className="tw-flex tw-flex-col tw-gap-[24px]">
          {task?.name && (
            <div className="tw-text-14">
              <span className="tw-font-semibold">Appointment Details:</span> {task?.name}
            </div>
          )}

          <div className="tw-pb-4px tw-grid tw-grid-cols-2 tw-gap-[24px] tw-justify-between">
            <OutcomeSelection
              task={task || {}}
              handleOutcomeOnChange={(outcome) => updateTask("outcome", outcome)}
            />
            <DatePicker
              containerClassName="tw-flex-1"
              value={dayjs.unix(task?.scheduled_time).format(`${DATE_FORMAT} hh:mm A`) || ""}
              enableTimePicker
              inputProps={{
                id: "due_on",
                disabled: false,
                isRequired: true,
                label: "Date & Time",
              }}
              onChange={handleDateOnChange}
              position="bottom"
              menuShouldComeToFront
            />
          </div>
          <TextInput
            label="Notes"
            className="!tw-w-[554px]"
            multiline
            rows={5}
            name="notes"
            placeholder="Anything you'd like to add about this appointment?"
            value={task?.note || ""}
            onChange={(e) => updateTask("note", e.target.value)}
          />
        </div>
      </Modal.Body>

      <Modal.Footer className="tw-flex tw-justify-between">
        <Button
          onClick={closeModal}
          className="tw-px-[20px] tw-py-[8px] tw-flex tw-items-center"
          schema="tertiary"
          size="medium"
        >
          Cancel
        </Button>
        <Button
          className="tw-flex tw-items-center"
          size="medium"
          schema="primary"
          disabled={!task.outcome}
          onClick={handleSubmit}
        >
          Complete
          <span className="tw-pl-[6px]">
            <CheckSolidV6 />
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

AppointmentCompleteModal.propTypes = {
  modalOpen: Proptypes.bool,
  closeModal: Proptypes.func,
  handleSubmit: Proptypes.func,
  task: Proptypes.shape({ name: Proptypes.string, scheduled_time: Proptypes.number, note: Proptypes.string, outcome: Proptypes.string }),
  updateTask: Proptypes.func,
};
AppointmentCompleteModal.defaultProps = {
  modalOpen: false,
  closeModal: null,
  handleSubmit: null,
  task: { name: "", scheduled_time: null, note: "", outcome: "" },
  updateTask: null,
};
export default AppointmentCompleteModal;
